import { ConfigProvider, Switch } from "antd";
import Commonformlabel from "./CommonFormLabel";
import Commonformerror from "./CommonFormError";

function Commonswitch({
  checked,
  onClick,
  labelname,
  required = false,
  touched,
  name,
  error,
}: {
  checked: boolean;
  onClick: () => void;
  labelname: string;
  required?: boolean;
  touched?: any;
  name: string;
  error?: any;
}) {
  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorTextLightSolid: "#0f0f0f",
          },
        }}
      >
        <Commonformlabel
          labelname={labelname}
          required={required}
          style={{
            marginBottom: "1rem",
          }}
        />

        <Switch
          checkedChildren="ON"
          unCheckedChildren="OFF"
          checked={checked}
          onClick={onClick}
        />

        <Commonformerror
          required={required}
          touched={touched}
          name={name}
          error={error}
        />
      </ConfigProvider>
    </>
  );
}

export default Commonswitch;
